import type { CashSubLine } from '../types/shiftCashBreakdown';
import { formatMoney, formatQuantity } from './costFormatting';

// FI-22 · Entrega 3: cómo se lee un renglón del detalle del turno. Puro y probado.
// Compra: «8 L × $32.00» (cantidad, unidad y costo unitario, como en la lista de Compras).
// Gasto: sin detalle (la etiqueta ya dice el tipo). Tolera renglones sin cantidad.
export function describeCashSubLine(line: CashSubLine): string | null {
  if (line.quantity === undefined || line.unitSymbol === undefined || line.unitCost === undefined) return null;
  return `${formatQuantity(line.quantity)} ${line.unitSymbol} × ${formatMoney(line.unitCost)}`;
}
